import { apis, serviceInterface } from "./config";

export const getAllIndustries = () => {
  return serviceInterface.get(apis.INDUSTRY);
};

export const getIndustryById = id => {
  return serviceInterface.get(`${apis.INDUSTRY}"/"${id}`);
};
